// Envision - Replace Skio "select" dropdown with buttons

if (!window._pc07Active) {

  waitForElm("select[skio-selling-plans]").then(() => {
    document.querySelectorAll("select[skio-selling-plans]").forEach(function (select) {
        const buttonGroup = document.createElement("div");
        buttonGroup.classList.add("btn-group");
        select.querySelectorAll("option").forEach(function (option, index) {
            const button = document.createElement("button");
            button.setAttribute("type", "button");
            button.classList.add("btn");
            button.innerText = option.innerText.replace(/Delivery every/i, "").trim();
            button.addEventListener("click", function () {
                select.value = option.value;
                select.dispatchEvent(new Event("change"));
                buttonGroup.querySelectorAll("button").forEach(function (button) {
                    button.classList.remove("active");
                });
                button.classList.add("active");
            });
            buttonGroup.appendChild(button);
            if (index === 0) {
                button.classList.add("active");
            }
        });
        select.after(buttonGroup);
        select.style.display = "none";
    });

    function replaceMainPriceWithSelectedSkioPrice(skioInputElement) {
        const inputId = skioInputElement.getAttribute("id");
        const label = skioInputElement.parentElement.querySelector(`label[for=${inputId}]`);
        const price = label.querySelector(".skio-price span").innerText;
        document.querySelectorAll(".product__price[data-product-price]").forEach(function (priceElement) {
            priceElement.innerText = price;
        });
    }

    document.querySelectorAll("input[name^=skio-group-]").forEach(function (input) {
        input.addEventListener("change", function () {
            replaceMainPriceWithSelectedSkioPrice(input);
        });
    });

    document.querySelectorAll("input[name=Size]").forEach(function (input) {
        input.addEventListener("change", function () {
            const checkedSkioGroupInput = document.querySelector("input[name^=skio-group-]:checked");
            if (checkedSkioGroupInput) {
                replaceMainPriceWithSelectedSkioPrice(checkedSkioGroupInput);
            }
        });
    });
  });

} // end: skip when pc07 is active

// Envision - Bundle product functionality

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-add-bundle]").forEach(function (button) {
        button.addEventListener("click", function (event) {
            event.preventDefault();

            // This ENVISION.bundle_products variable definition can be found in bundle-js-variables.liquid
            if (typeof ENVISION !== "undefined" && typeof ENVISION.bundle_products !== "undefined" && ENVISION.bundle_products.bundle_enabled) {
                const bundleId = Date.now();
                const requestData = {
                    items: []
                };

                for (let i = 0; i < ENVISION.bundle_products.variants.length; i++) {
                    const bundleVariant = ENVISION.bundle_products.variants[i];
                    requestData.items.push({
                        id: bundleVariant.id,
                        quantity: bundleVariant.quantity,
                        properties: {
                            "_is_bundle": "true",
                            "_bundle_id": `${bundleId}`,
                            "_bundle_handle": `${ENVISION.bundle_products.bundle_product_handle}`,
                            "_bundle_quantity": `${bundleVariant.quantity}`
                        }
                    });
                }

                button.setAttribute("disabled", true);
                fetch(`${window.Shopify.routes.root}cart/add.js`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(requestData)
                }).then(function (response) {
                    button.removeAttribute("disabled");
                }).catch(function (error) {
                    console.log(error);
                    button.removeAttribute("disabled");
                });
            }
        });
    });
});

// Envision - Fix the issue of the originally-below the fold images not being loaded by AOS after the Wholesale Gorilla app turns them above the fold

document.addEventListener("wsgAjax", () => {
  if (window.AOS) AOS.refreshHard();
});

// Envision - Force reload Attentive CTA script when variant is changed

const attnContainer = document.getElementById('attn-inline-price-trigger');
if (attnContainer) {
  document.addEventListener("variant:change", () => {
    attnContainer.innerHTML = '';
    attnContainer.removeAttribute('data-product-price');
    attnContainer.removeAttribute('style');
    if (window.attn_tag_initialized) window.attn_tag_initialized = false;
    const oldScriptTag = document.head.querySelector('script[src*="cdn.attn.tv/tag/4-latest/unified-tag.js"]');
    if (oldScriptTag) {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    }
  });
}

// Envision - Normalize heading hierarchy utility
(function() {
  function normalizeHeadings(container, baseLevel) {
    if (!container || container.dataset.headingsNormalized === 'true') return;
    var headings = container.querySelectorAll('h1,h2,h3,h4,h5,h6');
    if (!headings.length) { container.dataset.headingsNormalized = 'true'; return; }
    var currentLevel = baseLevel - 1;
    var lastPresentLevel = null;
    var lastNormalizedLevel = null;
    headings.forEach(function(h) {
      var presentLevel = parseInt(h.tagName.slice(1), 10);
      var level = isNaN(presentLevel) ? baseLevel : presentLevel;
      if (level < baseLevel) level = baseLevel;
      if (level > currentLevel + 1) level = currentLevel + 1;
      if (level > 6) level = 6;

      // If previous heading of the same present level was downgraded,
      // keep this one at the same normalized level to maintain sibling depth.
      if (
        lastPresentLevel !== null &&
        lastNormalizedLevel !== null &&
        presentLevel === lastPresentLevel &&
        lastNormalizedLevel < lastPresentLevel
      ) {
        level = lastNormalizedLevel;
      }

      if (level !== presentLevel) {
        var newEl = document.createElement('h' + level);
        Array.prototype.forEach.call(h.attributes, function(attr) { newEl.setAttribute(attr.name, attr.value); });
        newEl.innerHTML = h.innerHTML;
        if (!isNaN(presentLevel) && presentLevel >= 1 && presentLevel <= 6) {
          newEl.classList.add('h' + presentLevel);
        }
        h.parentNode.replaceChild(newEl, h);
        h = newEl;
      }
      currentLevel = level;
      lastPresentLevel = presentLevel;
      lastNormalizedLevel = level;
    });
    container.dataset.headingsNormalized = 'true';
  }

  function scan(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-normalize-headings]').forEach(function(el) {
      var base = parseInt(el.getAttribute('data-normalize-headings'), 10);
      if (isNaN(base) || base < 1 || base > 6) base = 2;
      normalizeHeadings(el, base);
    });
  }

  document.addEventListener('DOMContentLoaded', function() { scan(document); });
  document.addEventListener('shopify:section:load', function(e) { scan(e.target); });
  document.addEventListener('shopify:section:reorder', function() { scan(document); });
})();

// Envision - Force Rebuy widget (#rebuy-widget-84216) title to H2
waitForElm('#rebuy-widget-84216').then(function(container) {
  function upgradeRebuyTitle(root) {
    var scope = root || container;
    var title = scope.querySelector('h4.primary-title');
    if (!title) return;
    var h2 = document.createElement('h2');
    Array.prototype.forEach.call(title.attributes, function(attr) { h2.setAttribute(attr.name, attr.value); });
    h2.innerHTML = title.innerHTML;
    title.parentNode.replaceChild(h2, title);
  }

  // Initial run
  upgradeRebuyTitle(container);

  // Observe for dynamic re-renders by Rebuy
  var obs = new MutationObserver(function(muts) {
    for (var i = 0; i < muts.length; i++) {
      var mt = muts[i];
      if (mt.type === 'childList') {
        upgradeRebuyTitle(mt.target);
      }
    }
  });
  obs.observe(container, { childList: true, subtree: true });
});

// Envision - Force Rebuy widget (#rebuy-widget-142908) titles to desired levels
waitForElm('#rebuy-widget-142908').then(function(container) {
  function replaceHeading(el, newTag) {
    if (!el || el.tagName.toLowerCase() === newTag.toLowerCase()) return;
    var newEl = document.createElement(newTag);
    Array.prototype.forEach.call(el.attributes, function(attr) { newEl.setAttribute(attr.name, attr.value); });
    newEl.innerHTML = el.innerHTML;
    el.parentNode.replaceChild(newEl, el);
  }

  function upgradeRebuyTitles(root) {
    var scope = root || container;
    var superTitle = scope.querySelector('h3.super-title');
    var primaryTitle = scope.querySelector('h4.primary-title');
    replaceHeading(superTitle, 'h2');
    replaceHeading(primaryTitle, 'h3');
  }

  // Initial run
  upgradeRebuyTitles(container);

  // Observe for dynamic re-renders by Rebuy
  var obs = new MutationObserver(function(muts) {
    for (var i = 0; i < muts.length; i++) {
      var mt = muts[i];
      if (mt.type === 'childList') {
        upgradeRebuyTitles(mt.target);
      }
    }
  });
  obs.observe(container, { childList: true, subtree: true });
});